import React, { FC } from 'react';

import classes from '../chat-messaging.module.css';

interface IChatMessageOperator {
    message: string;
}

const ChatMessageOperator: FC<IChatMessageOperator> = ({ message }) => {
    return (
        <div className={`${classes['operator']} ${classes['chat-message']}`}>
            <p className={classes['name']}>Auctioneer</p>
            <p className={classes['message']}>{message}</p>
        </div>
    );
};

export default ChatMessageOperator;
